var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKiosk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.635,
    height: 22.944,
    viewBox: "0 0 28.635 22.944",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1253.662 -5186.589)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-1235.772,5187.589a5.606,5.606,0,0,0-5.6,5.6,5.606,5.606,0,0,0,5.6,5.6,5.606,5.606,0,0,0,5.6-5.6A5.606,5.606,0,0,0-1235.772,5187.589Zm0,10a4.406,4.406,0,0,1-4.4-4.4,4.406,4.406,0,0,1,4.4-4.4,4.406,4.406,0,0,1,4.4,4.4A4.406,4.406,0,0,1-1235.772,5197.589Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-1234.722,5195.03a1.916,1.916,0,0,1-.628.107,1.944,1.944,0,0,1-1.843-1.349h1.2a.6.6,0,0,0,.6-.6.6.6,0,0,0-.6-.6h-1.2a1.958,1.958,0,0,1,2.466-1.242.6.6,0,0,0,.76-.377.6.6,0,0,0-.376-.76,3.18,3.18,0,0,0-1.013-.169,3.151,3.151,0,0,0-3.087,2.548h-.348a.6.6,0,0,0-.6.6.6.6,0,0,0,.6.6h.348a3.151,3.151,0,0,0,3.087,2.548,3.165,3.165,0,0,0,1.015-.169.6.6,0,0,0,.374-.762A.6.6,0,0,0-1234.722,5195.03Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M947.416,1080.151l-4,1.558a1.817,1.817,0,0,0,.019-.184,2.063,2.063,0,0,0-2.06-2.061h-3.46a6.866,6.866,0,0,0-4.857-2.02h-4.188v-.665a1.006,1.006,0,0,0-1-1h-2.973a1,1,0,0,0-1,1v9.583a1.006,1.006,0,0,0,1,1.006h2.973a1.006,1.006,0,0,0,1-1.006v-.7l7.006,2.495a7,7,0,0,0,5.373-.292l10.951-5.3a.574.574,0,0,0,.228-.832A4.217,4.217,0,0,0,947.416,1080.151Zm-19.691,6.069h-2.691v-9.3h2.691Zm13.025.617a5.857,5.857,0,0,1-4.488.243l-7.391-2.632v-5.86h4.188a5.723,5.723,0,0,1,4.193,1.835.569.569,0,0,0,.42.184h3.7a.914.914,0,0,1,.373,1.749l-.05.02a.9.9,0,0,1-.323.062h-6.709a.573.573,0,0,0,0,1.145h6.709a2.033,2.033,0,0,0,.592-.1.6.6,0,0,0,.065-.011l.115-.045.045-.017,5.64-2.2a3.071,3.071,0,0,1,3.212.642Z",
    transform: "translate(-2177.551 4120.973)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKiosk);
export default __webpack_public_path__ + "static/media/kiosk.0b6fce80977ad2fb61632f9e6bd0c5da.svg";
export { ForwardRef as ReactComponent };